import { isValidAppPassword } from './credentialPolicy';

const PASSWORD_CHARACTERS =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_-+';
const GENERATED_PASSWORD_LENGTH = 12;

export const generatePassword = (): string => {
  const bytes = new Uint8Array(32);
  const unbiasedLimit = 256 - (256 % PASSWORD_CHARACTERS.length);
  let password: string;

  do {
    password = '';
    while (password.length < GENERATED_PASSWORD_LENGTH) {
      window.crypto.getRandomValues(bytes);
      for (let index = 0; index < bytes.length; index += 1) {
        const byte = bytes[index];
        // Reject the incomplete range to keep every character equally likely.
        if (byte < unbiasedLimit) {
          password += PASSWORD_CHARACTERS[byte % PASSWORD_CHARACTERS.length];
          if (password.length === GENERATED_PASSWORD_LENGTH) break;
        }
      }
    }
  } while (!isValidAppPassword(password));

  return password;
};
